import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getOrders as getOrdersApi,
  getOrdersbyFR as getOrdersbyFRApi,
  getClientOrders as getClientOrdersApi,
  getQuotesStats as getQuotesStatsApi,
  getOrdersStats as getOrdersStatsApi,
  addNewOrder as addNewOrderApi,
  updateOrder as updateOrderApi,
  updateOrdersBulk as updateOrdersBulkApi,
  deleteOrder as deleteOrderApi,
  getOrdersReceivers as getOrdersReceiversApi,
  getOrdersReceiversByName as getOrdersReceiversByNameApi,
  addNewOrderReceiver as addNewOrderReceiverApi,
  updateOrderReceiver as updateOrderReceiverApi,
  deleteOrderReceiver as deleteOrderReceiverApi,
  getOrdersSenders as getOrdersSendersApi,
  getOrdersSendersByName as getOrdersSendersByNameApi,
  addNewOrderSender as addNewOrderSenderApi,
  updateOrderSender as updateOrderSenderApi,
  deleteOrderSender as deleteOrderSenderApi,
  getCustomClearances as getCustomClearancesApi,
  addNewCustomClearance as addNewCustomClearanceApi,
  updateCustomClearance as updateCustomClearanceApi,
  deleteCustomClearance as deleteCustomClearanceApi,
  getCustomDeclarations as getCustomDeclarationsApi,
  addNewCustomDeclaration as addNewCustomDeclarationApi,
  updateCustomDeclaration as updateCustomDeclarationApi,
  deleteCustomDeclaration as deleteCustomDeclarationApi,
} from "../../helpers/realbackend_helper";

export const getOrders = createAsyncThunk(
  "order/getOrders",
  async ({ beginDate, lastDate, employee }, { rejectWithValue }) => {
    try {
      const response = await getOrdersApi(beginDate, lastDate, employee);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Orders");
    }
  }
);

export const getClientOrders = createAsyncThunk(
  "order/getClientOrders",
  async ({ beginDate, lastDate, company }, { rejectWithValue }) => {
    try {
      const response = await getClientOrdersApi(beginDate, lastDate, company);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Orders");
    }
  }
);

export const getOrdersbyFR = createAsyncThunk(
  "order/getOrdersbyFR",
  async ({ beginDate, lastDate, company }, { rejectWithValue }) => {
    try {
      const response = await getOrdersbyFRApi(beginDate, lastDate, company);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Orders");
    }
  }
);

export const getQuotesStats = createAsyncThunk(
  "order/getQuotesStats",
  async ({ beginDate, lastDate, company, employee }, { rejectWithValue }) => {
    try {
      const response = await getQuotesStatsApi(
        beginDate,
        lastDate,
        company,
        employee
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Stats");
    }
  }
);

export const getOrdersStats = createAsyncThunk(
  "order/getOrdersStats",
  async ({ beginDate, lastDate, company, employee }, { rejectWithValue }) => {
    try {
      const response = await getOrdersStatsApi(
        beginDate,
        lastDate,
        company,
        employee
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Stats");
    }
  }
);

export const addNewOrder = createAsyncThunk(
  "order/addNewOrder",
  async (order, { rejectWithValue }) => {
    try {
      const response = await addNewOrderApi(order);

      toast.success("Захиалга амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      console.log("Дэлгэрэнгүй алдаа:", error.response?.data || error.message);
      toast.error("Захиалга бүртгэхэд алдаа гарлаа!" + error.message);
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async (order) => {
    try {
      const response = updateOrderApi(order);
      toast.success("Захиалга амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Захиалга засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrdersBulk = createAsyncThunk(
  "order/updateOrdersBulk",
  async (orders, { rejectWithValue }) => {
    try {
      const response = await updateOrdersBulkApi(orders);
      toast.success("Захиалгууд амжилттай шинэчлэгдлээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      console.error("Bulk update error:", error);
      toast.error("Захиалгыг шинэчлэхэд алдаа гарлаа", { autoClose: 3000 });
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "order/deleteOrder",
  async (id, { rejectWithValue }) => {
    try {
      await deleteOrderApi(id);

      toast.success("Захиалга амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Захиалга устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//=============================== getOrdersSenders ==================================

export const getOrdersSenders = createAsyncThunk(
  "order/getOrdersSenders",
  async () => {
    try {
      const response = await getOrdersSendersApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOrdersSendersByName = createAsyncThunk(
  "order/getOrdersSendersByName",
  async (ordersSenders) => {
    try {
      const response = await getOrdersSendersByNameApi(ordersSenders);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewOrderSender = createAsyncThunk(
  "order/addNewOrderSender",
  async (order) => {
    try {
      const response = addNewOrderSenderApi(order);
      toast.success("Гадаад агентыг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гадаад агент бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrderSender = createAsyncThunk(
  "order/updateOrderSender",
  async (order) => {
    try {
      const response = updateOrderSenderApi(order);
      toast.success("Гадаад агентын мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гадаад агентын мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteOrderSender = createAsyncThunk(
  "order/deleteOrderSender",
  async (id, { rejectWithValue }) => {
    try {
      await deleteOrderSenderApi(id);

      toast.success("Гадаад агентын мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Гадаад агентын мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//=============================== getOrdersReceivers ==================================

export const getOrdersReceivers = createAsyncThunk(
  "order/getOrdersReceivers",
  async () => {
    try {
      const response = await getOrdersReceiversApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOrdersReceiversByName = createAsyncThunk(
  "order/getOrdersReceiversByName",
  async (ordersReceivers) => {
    try {
      const response = await getOrdersReceiversByNameApi(ordersReceivers);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewOrderReceiver = createAsyncThunk(
  "order/addNewOrderReceiver",
  async (order) => {
    try {
      const response = addNewOrderReceiverApi(order);
      toast.success("Хүлээн авагчийг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Хүлээн авагч бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrderReceiver = createAsyncThunk(
  "order/updateOrderReceiver",
  async (order) => {
    try {
      const response = updateOrderReceiverApi(order);
      toast.success("Хүлээн авагчийн мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Хүлээн авагчийн мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteOrderReceiver = createAsyncThunk(
  "order/deleteOrderReceiver",
  async (id, { rejectWithValue }) => {
    try {
      await deleteOrderReceiverApi(id);

      toast.success("Хүлээн авагчийн мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Хүлээн авагчийн мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//=============================== getCustomClearances ==================================

export const getCustomClearances = createAsyncThunk(
  "order/getCustomClearances",
  async ({ beginDate, lastDate, employee }, { rejectWithValue }) => {
    try {
      const response = await getCustomClearancesApi(
        beginDate,
        lastDate,
        employee
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Orders");
    }
  }
);

export const addNewCustomClearance = createAsyncThunk(
  "order/addNewCustomClearance",
  async (order) => {
    try {
      const response = addNewCustomClearanceApi(order);
      toast.success("Гаалийн бүрдүүлэлтийг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гаалийн бүрдүүлэлт бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateCustomClearance = createAsyncThunk(
  "order/updateCustomClearance",
  async (order) => {
    try {
      const response = updateCustomClearanceApi(order);
      toast.success("Гаалийн бүрдүүлэлтийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гаалийн бүрдүүлэлтийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteCustomClearance = createAsyncThunk(
  "order/deleteCustomClearance",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCustomClearanceApi(id);

      toast.success("Гаалийн бүрдүүлэлтийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Гаалийн бүрдүүлэлтийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//=============================== getCustomDeclarations ==================================

export const getCustomDeclarations = createAsyncThunk(
  "order/getCustomDeclarations",
  async ({ beginDate, lastDate, employee }, { rejectWithValue }) => {
    try {
      const response = await getCustomDeclarationsApi(
        beginDate,
        lastDate,
        employee
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Orders");
    }
  }
);

export const addNewCustomDeclaration = createAsyncThunk(
  "order/addNewCustomDeclaration",
  async (order) => {
    try {
      const response = addNewCustomDeclarationApi(order);
      toast.success("Гаалийн мэдүүлгийг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гаалийн мэдүүлгийг бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateCustomDeclaration = createAsyncThunk(
  "order/updateCustomDeclaration",
  async (order) => {
    try {
      const response = updateCustomDeclarationApi(order);
      toast.success("Гаалийн мэдүүлгийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Гаалийн мэдүүлгийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteCustomDeclaration = createAsyncThunk(
  "order/deleteCustomDeclaration",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCustomDeclarationApi(id);

      toast.success("Гаалийн мэдүүлгийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Гаалийн мэдүүлгийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      console.log(error);

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
